import React from 'react';
import UPPage from '../components/UPPage';
import { RouteComponentProps } from 'react-router';

const LoginFormLazy = React.lazy(() =>
  import('./../components/LoginWithWebToken')
);

/**
 * Main Page
 */
export default function(
  props: RouteComponentProps<{
    webToken: string;
    contractID: string;
    [key: number]: string;
  }>
) {
  let content;
  content = (
    <LoginFormLazy
      webToken={props.match.params.webToken}
      contractID={props.match.params.contractID || props.match.params[0]}
    />
  );

  return <UPPage>{content}</UPPage>;
}
